export const getRegistryOkvedItemKey = (inn: string, ogrn: string) => `${inn}/${ogrn}`;
